<mat-drawer-container class="w-full" autosize>

    <mat-drawer #drawer class="example-sidenav " mode="side">
  
      <div class="pt-5 px-5">
        <button class="btn btn-circle btn-outline w-full" (click)="overallOverviewModal()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
          </svg>
          Overall Overview
        </button>
      </div>
  
      <!-- FILTER -->
      <div class="p-5 w-72">
        <div class="my-2 text-primary">Field</div>
        <mat-form-field class="w-full">
          <mat-select placeholder="Select Platform" [(ngModel)]="selectedField" (selectionChange)="onSelectField()">
            <mat-option [value]="'all'"> All </mat-option>
            <mat-option *ngFor="let field of fieldList" [value]="field"> {{ field.fieldLongName }} </mat-option>
          </mat-select>
        </mat-form-field>
  
        <div class="my-2 text-primary">Platform</div>
        <mat-form-field class="w-full">
          <mat-select placeholder="Select Platform" [(ngModel)]="selectedPlatform" (selectionChange)="onSelectPlatform()">
            <mat-option *ngFor="let platform of platformList" [value]="platform"> {{ platform.platformLongName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  
  
      <div class="bg-white px-5 pr-7">
        <div *ngIf="dataSource.data.length == 0" class="text-center" style="color:rgb(171, 171, 171)">
          Sorry, couldn't find any Well...
        </div>
  
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
          <!-- Node templates -->
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
  
            <button mat-icon-button *ngIf="node.nodeLevel == 'WellString'">
            </button>
  
            <button mat-icon-button *ngIf="node.nodeLevel != 'WellString'" matTreeNodeToggle
              [attr.aria-label]="'toggle ' + node.name">
              <mat-icon class="mat-icon-rtl-mirror">
                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
              </mat-icon>
            </button>
  
            <ng-container
              *ngTemplateOutlet="node.nodeLevel == 'Well' ? wellIcon : node.nodeLevel == 'Wellbore' ? wellboreIcon : wellStringIcon ">
            </ng-container>
  
            <div class="w-full" (mouseenter)="showDeleteButton=true" (mouseleave)="showDeleteButton=false">
              <div class="w-full flex-row items-center mr-10 node"
                [ngClass]="{'selectedNode': node.id == selectedNode.id }">
                <button class="node-button" (click)="pressTree(node)">
                  {{ node.longName || node.name }}
                </button>
  
                <!-- delete button -->
                <button class="px-3 delete-button" *ngIf="showDeleteButton || node.id == selectedNode.id"
                  (click)="deleteNode(node)">
                  <mat-icon class="icon-size-4" [svgIcon]="'heroicons_mini:trash'"
                    style="color: rgb(235, 132, 132);"></mat-icon>
                </button>
              </div>
            </div>
          </mat-tree-node>
        </mat-tree>
      </div>
    </mat-drawer>
  
    <div class="example-sidenav-content">
      <router-outlet></router-outlet>
    </div>
  
  </mat-drawer-container>
  
  <ng-template #wellIcon>
    <div style="margin-right: 10px;">
  
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 163.000000 247.000000"
        preserveAspectRatio="xMidYMid meet">
  
        <g transform="translate(0.000000,247.000000) scale(0.100000,-0.100000)" fill="#64748b" stroke="none">
          <path d="M790 2330 l0 -70 -153 0 c-193 0 -187 4 -187 -136 0 -116 9 -135 67
   -143 l39 -6 -201 -830 -201 -830 -27 -3 c-26 -3 -27 -5 -27 -68 l0 -64 765 0
   765 0 0 65 0 65 -30 0 c-16 0 -30 1 -30 3 0 2 -90 374 -200 827 -110 453 -200
   827 -200 832 0 4 14 8 30 8 20 0 40 9 56 25 25 25 26 30 22 126 -4 133 2 129
   -195 129 l-153 0 0 70 0 70 -70 0 -70 0 0 -70z m0 -441 l0 -91 -27 18 c-16 9
   -43 27 -60 38 -19 12 -31 27 -28 36 2 8 7 32 11 53 6 37 6 37 55 37 l49 0 0
   -91z m255 40 c17 -59 20 -54 -67 -109 l-48 -30 0 95 0 95 50 0 49 0 16 -51z
   m-320 -269 c0 -10 -116 -92 -123 -86 -3 4 27 126 35 139 6 10 88 -39 88 -53z
   m387 -15 c8 -41 13 -75 11 -75 -8 0 -123 84 -123 89 0 6 81 61 90 61 3 0 13
   -34 22 -75z m68 -292 c0 -10 -29 -13 -125 -13 l-125 0 0 95 0 94 125 -81 c69
   -45 125 -88 125 -95z m-390 77 l0 -90 -126 0 c-96 0 -125 3 -122 13 4 11 225
   165 241 166 4 1 7 -39 7 -89z m0 -255 l0 -95 -130 87 c-71 47 -130 90 -130 95
   0 4 59 8 130 8 l130 0 0 -95z m405 86 c-16 -14 -254 -171 -260 -171 -3 0 -5
   41 -5 90 l0 90 137 0 c78 0 133 -4 128 -9z m-466 -304 c1 -7 -314 -217 -326
   -217 -8 0 1 40 48 222 l41 156 118 -76 c65 -43 119 -80 119 -85z m556 -38 c24
   -101 42 -185 40 -187 -4 -5 -325 210 -325 217 1 8 233 161 238 157 1 -2 23
   -86 47 -187z m-504 -257 c-6 -2 -21 -12 -33 -22 -21 -17 -23 -27 -23 -113 0
   -131 6 -137 136 -137 131 0 139 8 139 131 0 72 -3 91 -21 113 -11 14 -27 26
   -35 26 -11 0 -14 17 -14 81 0 47 4 79 10 77 5 -1 106 -68 224 -148 l215 -145
   24 -100 c13 -55 22 -103 20 -108 -2 -4 -256 -7 -564 -7 -526 0 -559 1 -559 18
   0 9 11 58 23 107 l23 90 219 148 220 147 3 -77 c2 -47 -1 -79 -7 -81z" />
        </g>
      </svg>
    </div>
  </ng-template>
  
  <ng-template #wellboreIcon>
    <div style="margin-right: 5px;">
  
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="45" height="35" viewBox="0 0 204.000000 176.000000"
        preserveAspectRatio="xMidYMid meet">
  
        <g transform="translate(0.000000,176.000000) scale(0.100000,-0.100000)" fill="#64748b" stroke="none">
          <path d="M1310 1530 c0 -29 -2 -30 -45 -30 -42 0 -44 -1 -49 -32 -3 -18 -22
   -143 -41 -278 -19 -135 -39 -265 -43 -290 l-7 -45 -345 -5 -345 -5 -3 -22 -3
   -23 590 0 591 0 0 25 c0 23 -4 25 -45 25 -42 0 -44 2 -50 33 -7 42 -63 431
   -75 525 -5 40 -12 78 -15 83 -4 5 -22 9 -41 9 -31 0 -34 2 -34 30 0 23 -4 30
   -20 30 -16 0 -20 -7 -20 -30z m0 -113 c0 -24 8 -41 30 -62 29 -28 30 -28 44
   -9 21 28 32 9 40 -66 l7 -65 -97 96 c-79 79 -95 100 -89 118 4 15 15 21 36 21
   26 0 29 -3 29 -33z m95 13 c7 -21 -27 -80 -46 -80 -5 0 -9 23 -9 50 0 46 2 50
   24 50 16 0 27 -7 31 -20z m-128 -92 c32 -31 33 -34 33 -113 0 -75 2 -83 29
   -112 l29 -32 33 35 c18 19 37 34 41 34 4 0 8 -15 8 -32 1 -18 7 -66 14 -105 7
   -40 9 -73 6 -73 -12 0 -250 232 -250 244 0 7 9 21 20 31 11 10 20 25 20 33 0
   12 -7 9 -26 -9 l-27 -24 7 35 c4 19 9 54 13 78 3 23 8 42 11 42 3 0 21 -14 39
   -32z m125 -115 l38 -37 -37 -38 c-20 -21 -41 -38 -45 -38 -4 0 -8 34 -8 75 0
   41 3 75 7 75 4 0 24 -17 45 -37z m-140 -120 l48 -47 0 -101 0 -100 -72 0 c-48
   0 -73 4 -76 13 -2 7 19 37 47 68 65 71 70 106 6 44 -36 -36 -45 -40 -45 -25 0
   33 32 195 38 195 4 0 28 -21 54 -47z m165 -159 c32 -36 60 -70 61 -75 2 -5
   -28 -9 -67 -9 l-71 0 0 75 c0 41 4 75 9 75 5 0 36 -30 68 -66z" />
          <path d="M1158 678 l-3 -93 -326 -3 -326 -2 -1 -55 0 -55 384 0 384 0 -1 153
   c-1 83 -5 134 -8 113 l-6 -39 -35 29 c-19 16 -36 32 -38 37 -12 27 -22 -6 -24
   -85z m68 25 c31 -26 34 -33 34 -80 0 -29 -3 -53 -6 -53 -3 0 -24 14 -45 31
   -36 28 -39 35 -39 80 0 28 5 49 11 49 5 0 26 -12 45 -27z m-3 -134 c29 -24 37
   -37 35 -58 -2 -21 -9 -27 -34 -29 -23 -2 -42 7 -83 40 l-53 43 41 3 c28 2 41
   8 41 18 0 21 11 17 53 -17z m-627 -35 c24 -20 44 -40 44 -45 0 -5 -27 -9 -60
   -9 l-60 0 0 45 c0 57 15 58 76 9z m165 -1 c27 -20 49 -41 49 -45 0 -4 -27 -8
   -61 -8 -55 0 -66 4 -110 38 -26 20 -48 40 -49 45 0 4 28 7 61 7 56 0 67 -4
   110 -37z m175 1 c24 -20 44 -40 44 -45 0 -5 -28 -9 -62 -9 -56 0 -65 3 -115
   41 -29 23 -53 43 -53 45 0 2 32 4 71 4 66 0 73 -2 115 -36z m167 0 c26 -20 47
   -41 47 -45 0 -5 -29 -9 -64 -9 -60 0 -68 3 -115 40 -28 22 -51 43 -51 45 0 3
   31 5 68 5 64 0 72 -3 115 -36z" />
          <path d="M1390 570 l0 -200 -443 0 -443 0 0 -50 0 -50 498 0 498 0 0 250 0
   250 -55 0 -55 0 0 -200z" />
          <path d="M382 530 c0 -68 10 -74 66 -40 34 21 38 31 22 60 -8 15 -57 40 -80
   40 -5 0 -8 -27 -8 -60z" />
          <path d="M382 325 c0 -31 4 -58 8 -60 14 -8 70 17 80 35 16 29 12 39 -22 60
   -56 34 -66 28 -66 -35z" />
        </g>
      </svg>
    </div>
  </ng-template>
  
  <ng-template #wellStringIcon>
    <div style="margin-right: 5px;">
  
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="45" height="35" viewBox="0 0 391.000000 638.000000"
        preserveAspectRatio="xMidYMid meet">
  
        <g transform="translate(0.000000,638.000000) scale(0.100000,-0.100000)" fill="#64748b" stroke="none">
          <path d="M1168 5783 l-3 -318 -262 -3 c-225 -2 -263 -4 -263 -17 0 -12 18 -15
   93 -15 52 0 97 -3 100 -7 4 -3 0 -15 -10 -25 -13 -15 -31 -18 -100 -18 -49 0
   -83 -4 -83 -10 0 -6 27 -10 60 -10 43 0 60 -4 60 -13 0 -25 -24 -37 -72 -37
   -26 0 -48 -4 -48 -10 0 -5 11 -10 25 -10 16 0 25 -6 25 -15 0 -9 -11 -21 -25
   -27 -17 -8 -25 -19 -25 -37 0 -23 16 -10 121 97 l122 122 77 0 c42 0 80 -3 84
   -7 4 -4 -46 -60 -111 -125 -64 -64 -114 -121 -109 -125 4 -4 66 52 138 125
   125 126 134 133 167 130 36 -3 36 -3 39 -54 l3 -51 -71 -68 c-73 -71 -100
   -124 -34 -65 27 23 44 30 67 28 l32 -3 3 -2352 2 -2353 135 0 135 0 0 1000 0
   1000 155 0 155 0 0 -1000 0 -1000 135 0 135 0 0 1000 0 1000 185 0 185 0 0
   -1000 0 -1000 135 0 135 0 0 2355 0 2355 41 0 c40 0 41 -1 34 -27 -5 -24 2
   -20 61 37 37 36 96 95 132 133 l65 67 82 0 c45 0 85 -3 89 -7 4 -4 -49 -62
   -116 -130 -67 -68 -117 -123 -110 -123 7 0 71 59 142 130 l129 130 81 0 c64 0
   80 3 80 15 0 13 -46 15 -355 15 l-355 0 0 320 0 320 -135 0 -135 0 0 -1625 0
   -1625 -185 0 -185 0 0 1625 0 1625 -135 0 -135 0 0 -1625 0 -1625 -155 0 -155
   0 0 1625 0 1625 -135 0 -135 0 -2 -317z m822 -2478 l0 -2755 -100 0 -100 0 0
   2755 0 2755 100 0 100 0 0 -2755z m963 2118 c4 -3 0 -15 -10 -25 -14 -16 -33
   -18 -150 -18 l-133 0 0 25 0 25 143 0 c79 0 147 -3 150 -7z m-73 -76 c0 -29
   -25 -37 -122 -37 -98 0 -98 0 -98 25 l0 25 110 0 c84 0 110 -3 110 -13z m-70
   -72 c0 -22 -34 -35 -94 -35 -53 0 -56 1 -56 25 0 24 2 25 75 25 59 0 75 -3 75
   -15z m-1648 -30 c-12 -22 -27 -2 -18 22 5 12 10 13 17 6 7 -7 8 -17 1 -28z
   m594 -2449 c3 -14 4 -75 2 -138 l-3 -113 -158 -3 -157 -3 0 134 c0 74 3 137 7
   140 3 4 73 7 154 7 l149 0 6 -24z m624 -116 l0 -140 -175 0 -175 0 0 140 0
   140 175 0 175 0 0 -140z" />
          <path d="M3252 5287 c-56 -56 -102 -109 -102 -117 0 -8 13 -2 33 18 31 30 37
   32 111 32 49 0 75 4 71 10 -3 6 -28 10 -56 10 -33 0 -49 4 -49 13 0 24 24 37
   67 37 24 0 43 5 43 10 0 6 -11 10 -25 10 -14 0 -25 4 -25 9 0 5 11 18 25 29
   24 19 33 42 17 42 -4 0 -53 -46 -110 -103z" />
        </g>
      </svg>
    </div>
  </ng-template>